<template>
  <modal
    :modal-id="modalId"
    :title="modalTitle"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
  >
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="
          selectedUrl
            ? `transaction/profile-student/invoice-v2/createInvoice/${inputs.id}`
            : `transaction/profile-student/invoice-v2/createInvoice`
        "
      >
        <div class="form-group row align-items-center">
          <div class="col-sm-12">
            <app-input
              id="inputs_with_course_fee"
              :list-value-field="`With Course Fee`"
              type="single-checkbox"
              v-model="inputs.with_course_fee"
            />
          </div>
        </div>
        <div class="form-group row align-items-center">
          <label for="inputs_academic_calendar_id" class="col-sm-3 mb-0">
            Semester
          </label>

          <app-input
            id="inputs_academic_calendar_id"
            class="col-sm-9"
            type="advance-search-select"
            :loaded-per-time="10"
            v-model="input_academic_calendar_id"
            @input="setAcademicCalendarId"
            fetch-url="master/academic-calendar"
            placeholder="Semester"
            list-value-field="academic_calendar_name"
            :required="true"
          />
        </div>
        <div class="form-group row align-items-center">
          <label for="inputs_finance_book_code" class="col-sm-3 mb-0">
            Book
          </label>
          <app-input
            id="inputs_finance_book_code"
            class="col-sm-9"
            type="advance-search-select"
            :loaded-per-time="10"
            v-model="input_finance_book_code"
            @input="setFinanceBookIdValue"
            fetch-url="master/finance-book"
            placeholder="Finance Book"
            list-value-field="code"
            required
          />
        </div>
        <div
          class="form-group row align-items-center"
          v-if="inputs.with_course_fee"
        >
          <label for="inputs_product_id" class="col-sm-3 mb-0"> Product </label>
          <app-input
            id="inputs_product_id"
            class="col-sm-9"
            type="advance-search-select"
            :loaded-per-time="10"
            v-model="input_product_id"
            @input="setProductIdValue"
            fetch-url="master/product?product_category_exclude=3,2"
            placeholder="Product"
            list-value-field="name"
            :required="inputs.with_course_fee"
          />
        </div>
        <div
          class="form-group row align-items-center"
          v-if="inputs.with_course_fee"
        >
          <label for="inputs_packages_name" class="col-sm-3 mb-0">
            Package Name
          </label>
          <app-input
            id="inputs_packages_name"
            class="col-sm-9"
            type="advance-search-select"
            :loaded-per-time="10"
            v-model="input_packages_name"
            @input="setPackagesNameValue"
            :fetch-url="
              inputs.product_id && inputs.academic_calendar_id
                ? `master/list-packages?product_id=${inputs.product_id}&semester=${inputs.academic_calendar_id}`
                : ''
            "
            placeholder="Packages Name"
            list-value-field="package_name"
            :disabled="!inputs.product_id || !inputs.academic_calendar_id"
            :required="inputs.with_course_fee"
          />
        </div>
        <!-- <div class="form-group row align-items-center">
					<label for="inputs_print_date" class="col-sm-3 mb-0">
						Scheduled Print Date
					</label>
					<app-input
						type="date"
						v-model="inputs.print_date"
						class="col-sm-9"
						placeholder="Scheduled Print Date"
						:required="true"
					/>
				</div> -->
        <div class="form-group row align-items-center">
          <label for="inputs_due_date" class="col-sm-3 mb-0">
            Invoice Due Date (Type)
          </label>
          <app-input
            placeholder="Invoice Due Date Type"
            type="search-select"
            class="col-sm-9"
            v-model="input_due_date_type"
            @input="setInvoiceDueDateType"
            :list="invoiceDueDateTYpe"
            :required="true"
          />
        </div>
        <div class="form-group row align-items-center">
          <label for="inputs_bank_account_id" class="col-sm-3 mb-0">
            Bank Account
          </label>
          <app-input
            type="search-select"
            name="bank_account_id"
            class="col-sm-9"
            @input="setBankAccountValue"
            v-model="input_bank_account_id"
            :list="bankAccountIdLists"
            placeholder="Bank Account"
            :required="true"
          />
        </div>
        <list-available
          label="Voucher Applied"
          :url="`api/voucher/available?clc_id_number=${inputs.clc_id_number}&academic_calendar_id=${inputs.academic_calendar_id}`"
        ></list-available>
        <!-- <div class="form-group row align-items-center">
					<label for="input_request_send_via" class="col-sm-3 mb-0">
						Invoice Send Via
					</label>
					<app-input
						placeholder="Invoice Send Via"
						type="search-select"
						class="col-sm-9"
						v-model="input_request_send_via"
						@input="setInvoiceSendVia"
						:list="invoiceSentViaLists"
						:required="true"
					/>
				</div> -->
        <div class="form-group row align-items-center">
          <div class="col-sm-12 mb-0">
            <br />
          </div>
        </div>
        <div class="form-group row align-items-center">
          <div class="col-sm-12 mb-0">
            <br />
          </div>
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
import { FormMixin } from "../../../../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../../../../Mixins/ModalMixin";

export default {
  name: "ClassTableForm",
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    formId: String,
    value: {
      type: Object,
      default: () => {
        return {
          code: "",
          name: "",
          is_active: "",
        };
      },
    },
  },
  data() {
    return {
      preloader: false,
      inputs: {
        with_course_fee: true,
        bank_account_id: null,
        clc_id_number: this.value.clc_id_number || "",
        package_id: null,
        due_date: null,
		academic_calendar_id:null,
		product_id:null,
        invoice_sent_via: null,
      },
      input_packages_name: {},
      input_product_id: {},
      input_academic_calendar_id: {},
      input_finance_book_code: {},
      input_bank_account_id: null,
      input_request_send_via: null,
      input_due_date_type: null,
      invoiceDueDateTYpe: [
        { id: "Normal", value: "Normal" },
        { id: "Early_Bird", value: "Early Bird" },
        { id: "Late_Charges", value: "Late Charges" },
      ],

      // invoiceSentViaLists: [
      // 	{ id: "Email", value: "Email" },
      // 	{ id: "WhatsApp", value: "WhatsApp" },
      // ],
      bankAccountIdLists: [],
      modalId: this.formId,
      modalTitle: this.$t("add"),
    };
  },
  created() {
    // const pathParts = window.location.pathname.split("/");
    // const studentId = pathParts[pathParts.length - 1];
    // this.inputs.student_id = studentId;

    this.fetchData("created");
  },
  methods: {
    async fetchData(from) {
      try {
        // inputs.clc_id_number = userResponse.data.clc_id_number;

        const bankAccountResponse = await axios.get("/transaction/va-number", {
          params: { clc_id_number: this.inputs.clc_id_number },
        });

        this.bankAccountIdLists = (bankAccountResponse.data.data || []).map(
          (item) => ({
            id: item.id,
            value: `${item.bank?.bank_name ?? "-"} - ${item.account_number}`,
          })
        );
      } catch (err) {
        console.error("Gagal ambil bank account:", err);
      }
    },

    // setInvoiceSendVia(data) {
    // 	this.input_invoice_sent_via = data;
    // 	this.inputs.invoice_sent_via = data;
    // },

    setAcademicCalendarId(data) {
      this.inputs.academic_calendar_id = data.id;
      this.input_academic_calendar_id = data;
      this.fetchPackagesByProduct(this.inputs.product_id,this.inputs.academic_calendar_id);
    },
    setFinanceBookIdValue(data) {
      this.inputs.finance_book_code = data.code;
      this.input_finance_book_code = data;
    },

    setInvoiceDueDateType(data) {
      this.input_due_date_type = data;
      this.inputs.due_date_type = data;
    },

    setProductIdValue(data) {
      this.inputs.product_id = data?.id || null;

      if (!this.inputs.product_id) {
        this.input_packages_name = {};
        this.inputs.package_id = null;
        return;
      }

      this.fetchPackagesByProduct(this.inputs.product_id,this.inputs.academic_calendar_id);
    },
    async fetchPackagesByProduct(productId,AcademicCalendarId) {
		if (!productId || !AcademicCalendarId) {
			this.input_packages_name = {};
			this.inputs.package_id = null;
			return;
		}
		try {
			const res = await axios.get("/master/list-packages", {
			params: { product_id: productId,semester: AcademicCalendarId, },
			});

			const packages = res.data.data || [];

			if (packages.length === 1) {
				this.input_packages_name = packages[0];
				this.inputs.package_id = packages[0].id;
			} else {
		
				this.input_packages_name = {};
				this.inputs.package_id = null;
			}
		} catch (err) {
			console.error("Gagal ambil package:", err);
			this.input_packages_name = {};
			this.inputs.package_id = null;
		}
    },
    setPackagesNameValue(data) {
      this.inputs.package_id = data.id;
    },
    setBankAccountValue(data) {
      this.input_bank_account_id = data;
      this.inputs.bank_account_id = data;
    },
    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      this.$hub.$emit("reload-" + this.tableId);
    },
    // onPrintDateChange(value) {
    // 	this.inputs.print_date = value;
    // },
    submit() {
      this.inputs.invoice_sent_via = "Email";
      this.save(this.inputs);
    },
  },
};
</script>
